import {
  Component,
  Input,
  OnInit } from '@angular/core';
import { CompanyService } from '../companies/company.service';

import { VehicleModel } from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-info',
  template: require('./vehicle.info.component.html')
})
export class VehicleInfoComponent implements OnInit {
  @Input() vehicle : VehicleModel;

  public fleetCodeLabel   : string;
  public plateNumberLabel : string;
  public vinNumberLabel   : string;

  constructor (
    public companyService: CompanyService
  ) {}

  ngOnInit () : void {


    this.fleetCodeLabel   = this.companyService.labels.fleetCode;
    this.plateNumberLabel = this.companyService.labels.rego;
    this.vinNumberLabel   = this.companyService.labels.vin;


  }
}
